<template>
  <div class="DonutChart" :style="`height: ${height}px; width: ${height}px`">
    <canvas ref="chart" />
    <div class="percent" :style="`font-size: ${fontSize}rem; top: ${top}%`">
      {{ parseFloat(percent).toFixed(0) }}
      <span class="percent-symbol">%</span>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";
export default {
  name: "DonutChart",
  props: {
    height: {
      type: Number,
      required: false
    },
    top: {
      type: Number,
      required: false
    },
    fontSize: {
      type: Number,
      required: false
    },
    percent: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      chartObj: null,
      chart: null,
      dataTally: null,
      options: {
        cutoutPercentage: 75,

        responsive: true,
        maintainAspectRatio: false,

        legend: {
          display: false
        },
        tooltips: {
          enabled: false
        },
        labels: {
          enabled: false
        }
      },
      pieChartData: {
        labels: ["green", "red"],
        datasets: [
          {
            backgroundColor: ["green", "red"],
            borderColor: "black",
            data: [10]
          }
        ]
      }
    };
  },
  methods: {
    setupChart() {
      if (this.chartObj != null) {
        this.chartObj.destroy();
      }
      this.chartObj = new Chart(this.chart, {
        type: "doughnut",
        data: this.pieChartData,
        options: this.options
      });
    }
  },
  mounted() {
    this.chart = this.$refs.chart;
    this.pieChartData = {
      datasets: [
        {
          backgroundColor: ["green", "#f2f2f2"],
          borderColor: "transparent",
          data: [this.percent, 100 - parseInt(this.percent)]
        }
      ]
    };
    this.setupChart();
  }
};
</script>

<style lang="scss">
.DonutChart {
  height: 50px;
  width: 50px;
  position: relative;
  .percent {
    font-size: 1.8rem;
    display: flex;
    justify-content: center;
    align-content: center;
    position: absolute;
    width: 100%;
    top: 20%;
    font-weight: bold;
    text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff,
      1px 1px 0 #fff;
    .percent-symbol {
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      font-size: 1rem;
    }
  }
}
</style>
